export default __webpack_public_path__ + "static/media/BMBF_en.f33ab1e0.jpg";